import { useMantineColorScheme } from '@mantine/core';
import { isDarkScheme } from 'utils/theme';

export function useIsDarkMode(): boolean {
  const { colorScheme } = useMantineColorScheme();

  return isDarkScheme(colorScheme);
}
